import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, DatePicker, Form, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo-black.svg";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { useDownloadExcel } from "react-export-table-to-excel";
import { getDropshipSummary, getDropshipTotal } from "../../redux/actions/dropshipSummaryReports.action.js";
import { getAdminLocation } from "../../redux/actions/adminLocation.action.js";
import { getGender } from "../../redux/actions/gender.action.js";
import { CSVLink } from "react-csv";
import { toDateNew } from "../../utils/ToDate.js";

const DropshipTotal = ({ token }) => {
  TabTitle("DropShip Total")
  const { ecommerceDaily } = useSelector((state) => state);
  const userName = ReadCookie("name");
  const dispatch = useDispatch(); 
  const [form] = Form.useForm();
  const { Option } = Select;
  var date = moment();
  const [dateTypeId, setDateTypeId] = useState("lw");
  const [monthId, setMonthId] = useState(date.format("MM"));
  const [yearId, setYearId] = useState(date.format("Y"));
  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { gender, dropshipTotal } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");

  const { onDownload: onDownloadReport } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Dropship Total",
    sheet: "Sheet 1",
  });


  useEffect(() => {
    let year = yearId;
    let currentYearStartDate = moment().startOf("year").format("MM/DD/YYYY");
    let currentYearEndDate = moment().endOf("year").format("MM/DD/YYYY");
    if (dateTypeId === "mtd") {
      currentYearStartDate = moment().format("MM") + "/" + "01" + "/" + year;
      currentYearEndDate = moment().format("MM") + "/" + moment().format("DD") + "/" + year;
    } else if (dateTypeId === "lw") {
      currentYearStartDate = moment().subtract(7, 'days').format("MM/DD/YYYY");
      currentYearEndDate = moment().format("MM/DD/YYYY");
    } else if (dateTypeId === "stds") { // January to June only
      currentYearStartDate = moment().startOf('year').format("MM/DD/YYYY");
      currentYearEndDate = moment().month(5).date(30).format("MM/DD/YYYY");
    } else if (dateTypeId === "stdf") {
      currentYearStartDate = moment().startOf('year').add(6, 'months').startOf('month').format("MM/DD/YYYY");
      currentYearEndDate = moment().endOf('year').format("MM/DD/YYYY");
    } else if (dateTypeId === "ytd") {
      currentYearStartDate = moment().startOf('year').format("MM/DD/YYYY");
      currentYearEndDate = moment().endOf('year').format("MM/DD/YYYY");
    }
    const newState = {
      cy_start_date: currentYearStartDate,
      cy_end_date: currentYearEndDate,
    };
    setFormState(newState);
  }, [dateTypeId, monthId, yearId]);


  useEffect(() => {
    dispatch(getGender(token, menuId));
    dispatch(getAdminLocation(token, menuId));
  }, [dispatch, menuId, token]);


  console.log({ formState, dateTypeId })

  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(getDropshipTotal(token, values)).then((res) => {
        if (res.type === "GET_DROPSHIP_TOTAL_REPORTS_SUCCESS") {
          setLoading(false);
        downloadExcelFileData(res?.payload?.data);
        }
      });
    }).catch((error) => {
      setLoading(false);
    })
  }

  const [excelData, setExcelData] = useState([]);


  function downloadExcelFileData(data) {
      setExcelData(
        data.map((v) => {
          return {
            "SKU": v.sku,
            "Inseam": v.inseam,
            "Style": v.style_name,
            "Wash": v.wash_name,
            "Current Season": v.new_season,
            "Bloom SHP U": v.bloom_shipped,
            "Bloom RTRN U": v.bloom_returned,
            "Bloom NET U": v.bloom_net,
            "Bloom RET %": v.bloom_ret_rate,
            "Dia SHP U": v.dia_shipped,
            "Dia RTRN U": v.dia_returned,
            "Dia NET U": v.dia_net,
            "Dia RET %": v.dia_ret_rate,
            "Nord D2C SHP U": v.nord_shipped,
            "Nord D2C RTRN U": v.nord_returned,
            "Nord D2C NET U": v.nord_net,
            "Nord D2C RET %": v.nord_ret_rate,
            "Total SHP U": v.total_shipped,
            "Total RTRN U": v.total_returned,
            "Total NET U": v.total_net,
            "Total RET %": v.total_ret_rate,
          };
        })
      );
    }

  const handlePrint = () => {
    window.print();
  };

  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
      width: "20px"
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.sku.localeCompare(b.sku)
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.inseam - b.inseam
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.style_name - b.style_name
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.wash_name - b.wash_name
      },
    },
    {
      title: "Current Season",
      dataIndex: "new_season",
      key: "new_season",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.new_season - b.new_season
      },
    },
    {
      title: "Bloomingdales Dropship",
      children: [
        {
          title: "SHP U",
          dataIndex: "bloom_shipped",
          key: "bloom_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.bloom_shipped - b.bloom_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "bloom_returned",
          key: "bloom_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.bloom_returned - b.bloom_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "bloom_net",
          key: "bloom_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.bloom_net - b.bloom_net
          },
        },
        {
          title: "RET %",
          dataIndex: "bloom_ret_rate",
          key: "bloom_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.bloom_ret_rate - b.bloom_ret_rate
          },
        },
      ]
    },
    {
      title: "Dia SHOP - FullBeauty Brands",
      children: [
        {
          title: "SHP U",
          dataIndex: "dia_shipped",
          key: "dia_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.dia_shipped - b.dia_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "dia_returned",
          key: "dia_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.dia_returned - b.dia_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "dia_net",
          key: "dia_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.dia_net - b.dia_net
          },
        },
        {
          title: "RET %",
          dataIndex: "dia_ret_rate",
          key: "dia_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.dia_ret_rate - b.dia_ret_rate
          },
        },
      ]
    },
    // {
    //     title: "Lord & Taylor Dropship",
    //     children: [
    //       {
    //         title: "SHP U",
    //         dataIndex: "lt_shipped",
    //         key: "lt_shipped",
    //         className: " b_left b_bottom",
    //         align: "right",
    //         render: (text, record) => {
    //           return (
    //             <>
    //               {text}
    //             </>
    //           );
    //         },
    //         sorter: (a, b) => {
    //           return a.lt_shipped - b.lt_shipped
    //         },
    //       },
    //       {
    //         title: "RTRN U",
    //         dataIndex: "lt_returned",
    //         key: "lt_returned",
    //         className: " b_left b_bottom",
    //         align: "right",
    //         render: (text, record) => {
    //           return (
    //             <>
    //               {text}
    //             </>
    //           );
    //         },
    //         sorter: (a, b) => {
    //           return a.lt_returned - b.lt_returned
    //         },
    //       },
    //       {
    //         title: "NET U",
    //         dataIndex: "lt_net",
    //         key: "lt_net",
    //         className: " b_left b_bottom",
    //         align: "right",
    //         render: (text, record) => {
    //           return (
    //             <>
    //               {text}
    //             </>
    //           );
    //         },
    //         sorter: (a, b) => {
    //           return a.lt_net - b.lt_net
    //         },
    //       },
    //       {
    //         title: "RET %",
    //         dataIndex: "lt_ret_rate",
    //         key: "lt_ret_rate",
    //         className: " b_left b_bottom",
    //         align: "right",
    //         render: (text, record) => {
    //           return (
    //             <>
    //               {text}%
    //             </>
    //           );
    //         },
    //         sorter: (a, b) => {
    //           return a.lt_ret_rate - b.lt_ret_rate
    //         },
    //       },
    //     ]
    //   },
    {
      title: "Nordstrom Drop Ship",
      children: [
        {
          title: "SHP U",
          dataIndex: "nord_shipped",
          key: "nord_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_shipped - b.nord_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "nord_returned",
          key: "nord_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_returned - b.nord_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "nord_net",
          key: "nord_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_net - b.nord_net
          },
        },
        {
          title: "RET %",
          dataIndex: "nord_ret_rate",
          key: "nord_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}%
              </>
            );
          },
          sorter: (a, b) => {
            return a.nord_ret_rate - b.nord_ret_rate
          },
        },
      ]
    },
    {
      title: "Total",
      children: [
        {
          title: "SHP U",
          dataIndex: "total_shipped",
          key: "total_shipped",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_shipped - b.total_shipped
          },
        },
        {
          title: "RTRN U",
          dataIndex: "total_returned",
          key: "total_returned",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_returned - b.total_returned
          },
        },
        {
          title: "NET U",
          dataIndex: "total_net",
          key: "total_net",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return (
              <>
                {text}
              </>
            );
          },
          sorter: (a, b) => {
            return a.total_net - b.total_net
          },
        },
        {
          title: "RET %",
          dataIndex: "total_ret_rate",
          key: "total_ret_rate",
          className: " b_left b_bottom",
          align: "right",
          render: (text, record) => {
            return {
              props: {
                style: {
                  color: text >= 30 ? 'red' : 'inherit' // Set color conditionally
                }
              },
              children: `${(text)}%`
            };
          },
          sorter: (a, b) => {
            return a.total_ret_rate - b.total_ret_rate
          },
        },
      ]
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {dropshipTotal?.payload?.data ? (
                          <CSVLink
                          filename={"Dropship-Total.csv"}
                          data={excelData}
                          onClick={() => { }}
                        >
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        </CSVLink>
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Dropship Total
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>

                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <div className="col-12">
                        <hr className="my-1" />
                        <div className="row">
                        <div className="col-12 col-md-3">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            From:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              className="formFullWidth"
                              name="from_date"
                              initialValue={moment().startOf("year")}
                            >
                              <DatePicker
                                size="small"
                                defaultValue={moment().format("MM-DD-YYYY")}
                                className={"select_Inputs"}
                                format={"MM-DD-YYYY"}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-3">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            To:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              className="formFullWidth"
                              name="to_date"
                              initialValue={toDateNew()}
                            >
                              <DatePicker
                                size="small"
                                defaultValue={moment().format("MM-DD-YYYY")}
                                className={"select_Inputs"}
                                format={"MM-DD-YYYY"}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">Gender:</label>
                              <div className=" w-100">
                                <Form.Item name="gender_id" initialValue={"All"}>
                                  <Select
                                    className="formFullWidth"
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value={null}>All</Option>
                                    {gender &&
                                      gender?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.gender_id}>
                                            {it.gender_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <div style={{ marginTop: "3px", display: "flex", justifyContent: "right" }} d-flex flex-row align-items-baseline >
                                <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                                  Search
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{
          // overflowY: "scroll",
          // height: "45vh",
        }}
        ref={tableRef} >
        <div >
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : dropshipTotal?.payload?.data.length ? (

            <Table
              style={{ fontSize: '10.3px' }}
              className="test04 mt-3 sales_target_report_table sales_report_res_table_intransit ledger_print speciality_customer_size sales_report_res_table dropship-table-height"
              size="small"
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 100,
                pageSizeOptions: [100, 500, 1000]
            }}
              summary={pageData => {
                let bloomShip = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.bloom_shipped)
                }, 0);
                let bloomReturn = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.bloom_returned)
                }, 0);
                let bloomNet = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.bloom_net)
                }, 0);
                let diaShip = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.dia_shipped)
                }, 0);
                let diaReturn = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.dia_returned)
                }, 0);
                let diaNet = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.dia_net)
                }, 0);
                let ltShip = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.lt_shipped)
                }, 0);
                let ltReturn = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.lt_returned)
                }, 0);
                let ltNet = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.lt_net)
                }, 0);
                let nordShip = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.nord_shipped)
                }, 0);
                let nordReturn = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.nord_returned)
                }, 0);
                let nordNet = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.nord_net)
                }, 0);
                let totalShip = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.total_shipped)
                }, 0);
                let totalReturn = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.total_returned)
                }, 0);
                let totalNet = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.total_net)
                }, 0);
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right" }}>Total</p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(bloomShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(bloomReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(bloomNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell> 
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(diaShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(diaReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(diaNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell> 
                      <Table.Summary.Cell></Table.Summary.Cell>
                      {/* <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(ltShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(ltReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(ltNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell> */}
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(nordNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(totalShip.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(totalReturn.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(totalNet.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
              bordered
              columns={columns}
              scroll={{ x: "max-content" }}
              dataSource={dropshipTotal?.payload?.data}
            />
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DropshipTotal;

